import React from 'react';
import { Link } from 'react-router-dom';
import HomepageButton from '../HomepageButton';
import './WinningMoment.css';

const WinningMoment = () => {
  return (
    <div className="winning-moment-wrapper">
      <div className="winning-moment-left-panel">
        <div className="winning-moment-image" />
      </div>
      <div className="winning-moment-right-panel">
        <div className="winning-moment-sub-title">Wind Creek Property</div>
        <h2 className="winning-moment-title">Winning moment</h2>
        <div className="winning-momnent-content">
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem. Sed ut
          perspiciatis unde omni iste natus error sit voluptatem.
        </div>
        <Link to={'/hotel-booking'}>
          <HomepageButton title="Book a Stay" />
        </Link>
      </div>
    </div>
  );
};

export default WinningMoment;
